/* eslint-disable react-hooks/rules-of-hooks */
import * as React from "react";
import { useTranslation } from "react-i18next";
import { TableDataDefinition } from "../types";
import { FormattedNumber } from "../../FormattedNumber";
import { HangmanTableType } from "../../../graphql/generated";
import { SectionTableFragmentFragment } from "../../../graphql/SectionTableFragment.generated";
import { Column } from "react-table";

type TableType = Omit<SectionTableFragmentFragment, "metaData"> & {
  metaData: {
    bet: number;
    type: HangmanTableType;
    numberOfPlayers: number;
  };
};

type RowData = {
  players: string;
  bet: number;
};

export const tableData: TableDataDefinition<RowData> = {
  useColumns: (isChallenge: boolean) => {
    const { t } = useTranslation();
    return React.useMemo(() => {
      let result: Array<Column<RowData>> = [
        {
          Header: t<string>("players"),
          accessor: "players",
          Cell: ({ row }) => `${row.original.players}`,
        },
      ];

      if (!isChallenge)
        result = result.concat([
          {
            Header: t<string>("bet"),
            accessor: "bet",
            Cell: ({ row }) => <FormattedNumber value={row.original.bet} />,
          },
        ]);
      return result;
    }, [isChallenge, t]);
  },
  makeRow: (table: TableType) => ({
    players: `${table.players.length} / ${table.metaData.numberOfPlayers}`,
    bet: table.metaData.bet,
  }),

  calculateEntryFee: (table) => {
    return table.metaData.type === HangmanTableType.Private
      ? null
      : table.metaData.bet;
  },

  getRequiredPlayers: (table) => table.metaData.numberOfPlayers,

  getDetails: (table: TableType) => {
    const { t } = useTranslation();
    return (
      <>
        <div className="flex -mx-2 justify-between">
          <div className="px-2">{t("players")}</div>
          <div className="px-2">{`${table.players.length}`}</div>
        </div>
        <div className="flex -mx-2 justify-between">
          <div className="px-2">{t("bet")}</div>
          <div className="px-2">
            <FormattedNumber value={table.metaData.bet} />
          </div>
        </div>
      </>
    );
  },
};
